<template>
  <v-app>
    <top-bar />

    <v-main>
      <!-- <tabs /> -->
      <router-view></router-view>
    </v-main>

    <footer-component></footer-component>

    <v-snackbar bottom right :value="updateExists" :timeout="-1" color="primary">
      An update is available
      <v-btn text @click="refreshApp">
        Update
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import TopBar from './components/TopBar';
import Tabs from './components/Tabs';
import FooterComponent from './components/FooterComponent';
import updateContent from './mixins/updateContent.js'

export default {
  name: 'App',

  components: {
    TopBar,
    Tabs,
    FooterComponent
  },

  data: () => ({
    showTabs: false,
  }),
  mixins: [updateContent],
  created() {
    this.$store.dispatch('getSettings');
    if (this.$store.getters.loggedIn) {
      this.$store.dispatch('getCurrentWeek');
      this.$store.dispatch('getWeeks');
      this.$store.dispatch('getCurrentSeasonSdGames');
      this.$store.dispatch('getMaxGameWeek');
      this.showTabs = true;
    }
  }
};
</script>

<style>

  @font-face {
    font-family: "Barlow-Regular";
    src: url("./fonts/Barlow/Barlow-Regular.ttf") format("truetype");
  }

  @font-face {
    font-family: "Barlow-SemiBold";
    src: url("./fonts/Barlow/Barlow-SemiBold.ttf") format("truetype");
  }

  @font-face {
    font-family: "Barlow-Bold";
    src: url("./fonts/Barlow/Barlow-Bold.ttf") format("truetype");
  }

  @font-face {
    font-family: "Barlow-Medium";
    src: url("./fonts/Barlow/Barlow-Medium.ttf") format("truetype");
  }

  @font-face {
    font-family: "Barlow-Light";
    src: url("./fonts/Barlow/Barlow-Light.ttf") format("truetype");
  }

  @font-face {
    font-family: "Montserrat-Regular";
    src: url("./fonts/Montserrat/Montserrat-Regular.ttf") format("truetype");
  }

  @font-face {
    font-family: "Montserrat-SemiBold";
    src: url("./fonts/Montserrat/Montserrat-SemiBold.ttf") format("truetype");
  }


</style>
